"use client";

import { FC, useCallback, useEffect, useRef, useState } from "react";
import Swiper from "swiper";
import styles from "./review.module.scss";
import Image from "next/image";
import { Navigation, Scrollbar } from "swiper/modules";
import { Swiper as SwiperComp, SwiperRef, SwiperSlide } from "swiper/react";
import classNames from "classnames";
import { ReviewDataType } from "@/app/api/reviews/reviews";
import quoteLeft from "../../../assets/images/left_quote.svg";
import quoteRight from "../../../assets/images/right_quote.svg";
import next from "../../../assets/images/next_slide.svg";
import prev from "../../../assets/images/prev_slide.svg";
import "swiper/css";
import "swiper/css/effect-creative";
import "./reviewStyles.scss";
import "swiper/css/scrollbar";

export interface ReviewProps {
  reviews: ReviewDataType[];
}

export const Review: FC<ReviewProps> = ({ reviews = [] }) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const swiperRef = useRef<SwiperRef>(null);

  const slideRef = useRef<HTMLDivElement>(null);
  const scrollbarRef = useRef<HTMLDivElement>(null);

  const updateSwiper = () => {
    if (slideRef.current && scrollbarRef.current) {
      scrollbarRef.current.style.maxWidth = `${slideRef.current.clientWidth}px`;
      setTimeout(() => {
        swiperRef.current?.swiper.update();
      }, 500);
    }
  };

  useEffect(() => {
    const execIci = () => {
      setTimeout(() => {
        updateSwiper();
      }, 500);
    };
    execIci();
    window.addEventListener("resize", execIci);
    return () => {
      window.removeEventListener("resize", execIci);
    };
  }, []);

  const handleNav = (dir: "next" | "prev") => {
    if (swiperRef.current) {
      if (dir === "next") {
        swiperRef.current?.swiper.slideNext();
      } else {
        swiperRef.current?.swiper.slidePrev();
      }
    }
  };

  const handleSlideChange = useCallback((e: Swiper) => {
    const _currentIndex = e.activeIndex;
    setCurrentIndex(_currentIndex);
  }, []);

  return (
    <div className={classNames(styles.container_review, "review")}>
      <div id="swiper-contaniner" className={styles.swiper_container}>
        {currentIndex > 0 && (
          <div onClick={() => handleNav("prev")} className={styles.prev}>
            <Image src={prev} alt="Prev" />
          </div>
        )}
        <div className="w-full overflow-hidden py-[40px]">
          <SwiperComp
            ref={swiperRef}
            grabCursor
            centeredSlides
            slidesPerView={1}
            breakpoints={{
              640: {
                slidesPerView: 3,
              },
            }}
            scrollbar={{
              dragSize: 100,
              draggable: true,
              el: ".scroll-bar-container",
              snapOnRelease: true,
            }}
            spaceBetween={20}
            onSlideChange={handleSlideChange}
            className="mySwiper"
            modules={[Navigation, Scrollbar]}
            navigation
          >
            {reviews.map((reviews, index) => (
              <SwiperSlide key={reviews.id}>
                <div className="quote-left quote">
                  <Image src={quoteLeft} alt="quote left" />
                </div>
                <div
                  ref={index === 0 ? slideRef : null}
                  className={classNames(
                    styles.slide_container,
                    "slide-content"
                  )}
                >
                  <h3>Note : {reviews.global_rate}/10</h3>
                  <p className="slide-text">{reviews.comment}</p>
                  <p className="slide-author">- {reviews.user_name} -</p>
                </div>
                <div className="quote-right quote">
                  <Image src={quoteRight} alt="quote left" />
                </div>
              </SwiperSlide>
            ))}
          </SwiperComp>
        </div>
        {currentIndex < reviews.length - 1 && (
          <div onClick={() => handleNav("next")} className={styles.next}>
            <Image src={next} alt="Next" />
          </div>
        )}
      </div>
      <div className="flex justify-center col-span-full">
        <div
          ref={scrollbarRef}
          className="scroll-bar-container w-full border-[1px] border-flush-orange-500"
        ></div>
      </div>
    </div>
  );
};
